// extracted by mini-css-extract-plugin
export default {"inputContainer":"SearchInput_inputContainer__SLFFV","crossIcon":"SearchInput_crossIcon__H+XnJ"};